import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
export default class CallContractorModel extends CosmosJobsDbRecordBase {
  public forEmergencyTypeId: number
}
